/* src/app/pages/investments/modal-content/modal-content.component.scss */
.investment-details-content {
  width: 1080px;
  padding: 24px;
}
.loading-state {
  width: 100%;
}
.loading-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
  padding: 14px 0;
}
@media (max-width: 768px) {
  .loading-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 340px;
  text-align: center;
}
.error-state .error-image {
  width: 260px;
  max-width: 100%;
  height: auto;
  margin-bottom: 24px;
}
.error-state .error-title {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--cds-text-strong);
}
.error-state .error-subtitle {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: var(--cds-text-strong);
}
.investment-title {
  padding: 0;
}
.investment-title .title-text {
  font-size: 24px;
  font-weight: 700;
  color: var(--cds-text-strong);
  margin: 0;
}
.investment-info-section {
  padding: 20px 0 0;
}
.investment-info-section .section-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--cds-text-primary);
  margin: 0;
}
.investment-info-section .info-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.investment-info-section .info-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
  padding: 16px 0;
  border-bottom: 1px solid var(--cds-background-accent);
}
.investment-info-section .info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
@media (max-width: 768px) {
  .investment-info-section .info-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
.investment-info-section .info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.investment-info-section .info-item .info-label {
  font-size: 14px;
  color: var(--cds-text-strong);
  font-weight: 400;
}
.investment-info-section .info-item .info-value {
  font-size: 16px;
  font-weight: 600;
  color: var(--cds-text-strong);
}
.investment-info-section .info-item .info-value.credit {
  color: var(--cds-revenue);
}
.investment-info-section .info-item .info-value.debit {
  color: var(--cds-expense);
}
/*# sourceMappingURL=modal-content.component.css.map */
